import React from "react";
import { Navigate } from "react-router-dom";
import UserService from "services/UserService";


const ProtectedRoutes = ({children}) => {

    return UserService.isAuthenticated()? children : <Navigate to={'auth/sign-in'} replace={'/admin'}/>;
}
export default ProtectedRoutes;